// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + {"166":"6bd4217bb1","585":"7fd52e29bf"}[chunkId] + ".min.css";
};